import { render, staticRenderFns } from "./goodsOrderDetail.vue?vue&type=template&id=63b90c2f&scoped=true&"
import script from "./goodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./goodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrderDetail.vue?vue&type=style&index=0&id=63b90c2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b90c2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b90c2f')) {
      api.createRecord('63b90c2f', component.options)
    } else {
      api.reload('63b90c2f', component.options)
    }
    module.hot.accept("./goodsOrderDetail.vue?vue&type=template&id=63b90c2f&scoped=true&", function () {
      api.rerender('63b90c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/saleDetail/goodsOrderDetail.vue"
export default component.exports